import React from 'react';
import { Container, Row, Col, Alert } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import { ResponsiveBreadcrumb, type AppBreadcrumbItem } from './ResponsiveBreadcrumb';

interface PageLayoutProps {
  title: string;
  children: React.ReactNode;
  breadcrumbs?: AppBreadcrumbItem[];
  alert?: { variant: string; message: string };
  onAlertDismiss?: () => void;
  fluid?: boolean;
  className?: string;
  headerActions?: React.ReactNode;
  sidebar?: React.ReactNode;
  sidebarWidth?: number;
}

export const PageLayout: React.FC<PageLayoutProps> = ({
  title,
  children,
  breadcrumbs,
  alert,
  onAlertDismiss,
  fluid = false,
  className = '',
  headerActions,
  sidebar,
  sidebarWidth = 3,
}) => {
  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      
      <Container fluid={fluid} className={className}>
        {/* Breadcrumbs */}
        {breadcrumbs && breadcrumbs.length > 0 && (
          <Row className="mb-3">
            <Col>
              <ResponsiveBreadcrumb items={breadcrumbs} />
            </Col>
          </Row>
        )}

        {/* Alert */}
        {alert && (
          <Row className="mb-3">
            <Col>
              <Alert
                variant={alert.variant}
                dismissible={!!onAlertDismiss}
                onClose={onAlertDismiss}
              >
                {alert.message}
              </Alert>
            </Col>
          </Row>
        )}

        {/* Header */}
        <Row className="mb-4">
          <Col>
            <div
              className="d-flex align-items-center justify-content-between gap-2 w-100"
              style={{
                borderBottom: "2px solid var(--primary)",
                paddingBottom: "0.5rem",
              }}
            >
              <h1
                className="mb-0 flex-grow-1 min-w-0"
                style={{ borderBottom: "none", paddingBottom: 0 }}
              >
                {title}
              </h1>
              {headerActions && (
                <div className="d-flex gap-2 flex-shrink-0">
                  {headerActions}
                </div>
              )}
            </div>
          </Col>
        </Row>

        {/* Content */}
        <Row>
          {sidebar ? (
            <>
              <Col md={sidebarWidth}>
                {sidebar}
              </Col>
              <Col md={12 - sidebarWidth}>
                {children}
              </Col>
            </>
          ) : (
            <Col>
              {children}
            </Col>
          )}
        </Row>
      </Container>
    </>
  );
}; 
